import React, {Component} from "react";
import axios from "axios";
import ItemCard from './ItemCard';

const GigsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/`
})
class Searched extends Component{
    constructor(props) {
        super(props);
        this.state = {
          search: props.location.state.search,
          gigs:[],
        }
        this.getGigs();
      }
      getGigs = async () => {
        let data = []
        if(this.state.search){
            data = await GigsApi.get(`SearchedGigs/${this.state.search}/`).then(({data})=>data);
        }else{
            data = await GigsApi.get(`GigsAPI/`).then(({data})=>data);
        }
        
        this.setState({gigs:data})  
    }
    render() {
        return(
        <>
            <br/>
            <h1 className='mt-5 ms-3'> {this.state.search}</h1>
            <div className='container'>
            <br/>
            <div className="row row-cols-1 row-cols-md-4">
            {this.state.gigs.map(a =>  
                <div className="col mb-4">    
                    <ItemCard images={a.images} title={a.title} price ={a.price} details={a.details} seller={a.seller} itemID={a.id} rating={a.average_rating} />
                </div>
            )}
            </div>
            </div>
        </>
        )
     }
}
export default Searched;